import React, { useEffect, useState } from "react";

import {
    Download as DownloadIcon,
    EditNote,
    Insights,
    Share,
} from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import ButtonCircle from "../../../shared/components/button_circle";
import { ErrorComponent } from "../../../shared/pages/error";
import { convertArrayOfObjectsToCSV } from "../../../shared/util/functions";
import { projectList } from "../../../shared/util/projectList";
import { selectGtoState, useDispatch } from "../../../stateManagement/redux";
import { getReportWithData } from "../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { ReportInterface } from "../../../stateManagement/redux/slices/gerencia_tecnica/interfaces";
import { CartListForReport } from "./cart_with_info/cartListForReport";
import { DynamicTable } from "./reports_customs/dynamic-report";
import { SharedModal } from "./sharedModal";
import "./styles.scss";
import { DynamicDataGridTable } from "./reports_customs/datagrid-table";

const ReportViewer = ({
    report,
    onClose,
    filters,
}: {
    report: ReportInterface;
    onClose: any;
    filters: any;
}) => {
    const dispatch = useDispatch();

    const mainState = useSelector(selectGtoState);

    const [ReportBodyModule, setReportBodyModule] = useState<React.FC>();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const [showShareModal, setShowShareModal] = useState(false);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDownloadCSV = () => {
        try {
            if (mainState?.reportWithData) {
                const csv = convertArrayOfObjectsToCSV(
                    mainState.reportWithData
                );
                const blob = new Blob([csv], { type: "text/csv" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                a.setAttribute("download", "report.csv");
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        } catch (error) {
            console.log({ error });
        } finally {
            handleClose();
        }

        handleClose();
    };

    const handleDownloadPDF = async () => {
        // Implement PDF download logic here
        const project = projectList.find(
            (project) => project.projectId === filters.projectId
        );
        console.log("Descarga en PDF no implementado");
        // handleClose();
    };

    const handleSharedOpen = () => {
        setShowShareModal(true);
    };

    useEffect(() => {
        let requestData = false;

        if (report.type === "table-dynamic") {
            setReportBodyModule(() => () => (
                // <DynamicTable report={report} filters={filters} />
                <DynamicDataGridTable report={report} filters={filters} />
            ));
            requestData = true;
        } else {
            if (report.code === "nb-gt-003") {
                setReportBodyModule(() => () => (
                    <CartListForReport report={report} filters={filters} />
                ));
                requestData = true;
            } else {
                console.log("Module not available");
                setReportBodyModule(() => () => (
                    <ErrorComponent
                        type="403"
                        infoPage={`Module para el reporte ${report.name} no esta disponible aun!!`}
                    />
                ));
            }
        }

        if (requestData) {
            dispatch(
                getReportWithData(
                    report.id,
                    report.code,
                    filters.startDate,
                    filters.endDate,
                    filters.projectId
                )
            );
        }
    }, [report]);

    return (
        <>
            {showShareModal && (
                <SharedModal
                    report={report}
                    filters={filters}
                    onClose={() => setShowShareModal(false)}
                />
            )}
            <div className="report_viewer_header">
                <div className="options">
                    {/* Download */}
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<DownloadIcon />}
                        onClick={handleClick}
                        size="small"
                    >
                        Export
                    </Button>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {report?.config?.downloads?.includes("pdf") && (
                            <MenuItem onClick={handleDownloadPDF}>
                                Download PDF
                            </MenuItem>
                        )}
                        {report?.config?.downloads?.includes("csv") && (
                            <MenuItem onClick={handleDownloadCSV}>
                                Download CSV
                            </MenuItem>
                        )}
                    </Menu>

                    {/* Shared */}
                    <Button
                        variant="text"
                        color="primary"
                        startIcon={<Share />}
                        disabled={
                            !report?.config?.downloads?.includes("shared")
                        }
                        onClick={handleSharedOpen}
                        size="small"
                    >
                        Shared
                    </Button>

                    {/* Insight */}
                    <Button
                        variant="text"
                        color="primary"
                        startIcon={<Insights />}
                        onClick={() => { }}
                        size="small"
                        disabled
                    >
                        Insight
                    </Button>

                    {/* Notes */}
                    <Button
                        variant="text"
                        color="primary"
                        startIcon={<EditNote />}
                        onClick={() => { }}
                        size="small"
                        disabled
                    >
                        Notes
                    </Button>
                </div>
                <div>
                    <ButtonCircle
                        icon="/assets/icons/close.svg"
                        iconHeight={15}
                        iconWidth={15}
                        onClick={onClose}
                    />
                </div>
            </div>
            {ReportBodyModule && <ReportBodyModule />}
        </>
    );
};

export const StandAloneReportViewer = ({
    report,
    onClose,
    filters,
}: {
    report?: ReportInterface;
    onClose?: any;
    filters?: any;
}) => {
    return (
        <div className="report_viewer_body_container">
            {report && (
                <ReportViewer
                    report={report}
                    onClose={onClose}
                    filters={filters}
                />
            )}
        </div>
    )
};

export const ModalReportViewer = ({
    report,
    onClose,
    filters,
}: {
    report: ReportInterface;
    onClose: any;
    filters: any;
}) => {
    return (
        <div>
            <div className="report_viewer_modal_black_container" />
            <div className="report_viewer_modal_body_container">
                <ReportViewer
                    report={report}
                    onClose={onClose}
                    filters={filters}
                />
            </div>
        </div>
    );
};
